import { render } from "./ITComputing.vue?vue&type=template&id=2ee0f59a&scoped=true"
import script from "./ITComputing.vue?vue&type=script&lang=js"
export * from "./ITComputing.vue?vue&type=script&lang=js"

import "./ITComputing.vue?vue&type=style&index=0&id=2ee0f59a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee0f59a"]])

export default __exports__